// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BoAGr","left":"styles_left__2ggwx","right":"styles_right__2Du7X","alert":"styles_alert__2YS8t"};